module.exports = __webpack_public_path__ + "static/media/shaolaishan_mobile.8a1f8f83.webp";